import ArrondissementPage from "../ArrondissementPage";
import { arrondissementsData } from "@/mocks/arrondissements";

export default function ParisArrNordPage() {
  const data = arrondissementsData.find((a) => a.slug === "nord")!;
  return <ArrondissementPage data={data} />;
}
